import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-meilleurs-bien-tunis',
  templateUrl: './meilleurs-bien-tunis.component.html',
  styleUrls: ['./meilleurs-bien-tunis.component.scss']
})
export class MeilleursBienTunisComponent implements OnInit {

  public MeilleursBiens: any
  p: Number = 1;
  closeResult = '';
  public agencies:any
  search_name1:any;
  dataSource = new MatTableDataSource();
  public search: string  = ''

  constructor(private meilleursBiensService: MeilleursBiensService,
    
    private searchService: SearchService) { }
 ngOnInit(): void {
  this.getMeilleursBiensTunis();
     
  }
  getMeilleursBiensTunis() {
    this.meilleursBiensService.getMeilleursBiensTunis().subscribe((data: any) => {
    
      this.MeilleursBiens = data;
        
        console.log('meilleurs biens tunis',this.MeilleursBiens)
           // Filtrer les promoteurs de Tunis
      this.agencies = this.MeilleursBiens.filter((agencie: any) => {
        return agencie.region === 'Tunis'; 
        
        this.performSearch(); 

    })
  }

  
  )}


  
  SupprimerMeilleursBiens(MeilleursBiens, i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.meilleursBiensService.deleteMeilleursBiens(MeilleursBiens.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
  
          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
          // setTimeout(() => {
          //   this.getagencesTunis();
          // }, 500);

        });
        this.MeilleursBiens.splice(i, 1)

      }
    });
  }
// Méthode pour effectuer la recherche
performSearch() {
  this.MeilleursBiens = this.searchService.search(this.MeilleursBiens, this.search);
}
storeItemId(item: { id: string }) {
  // Extract and log the item ID
  const itemId = item.id;
  console.log(itemId);
  localStorage.setItem('storedItemId', itemId);
}

}